import trackOrderRoutes from 'sales-flow-ui/domains/track-order/_routes';
import orderSummaryRoutes from 'sales-flow-ui/domains/order-summary/_routes';
import contactRoutes from 'sales-flow-ui/domains/contact/_routes';
import cartRoutes from 'sales-flow-ui/domains/cart/_routes';
import checkoutRoutes from 'sales-flow-ui/domains/checkout/_routes';
import thankYouRoutes from 'sales-flow-ui/domains/thank-you/_routes';
import errorRoutes from 'sales-flow-ui/domains/error/_routes';
import VueRouter from 'vue-router';
import salesRoutes from 'sales-flow-ui/domains/sales/_routes';
import collectionRoutes from 'sales-flow-ui/domains/collection/_routes';

import homeRoutes from 'domains/home/_home-routes';
import staticRoutes from 'domains/static/_static-routes';
import marketplaceRoutes from 'domains/marketplace/_marketplace-routes';
import accountRoutes from 'domains/account/_account-routes';
import designerRoutes from 'domains/designer/_designer-routes';

let router = new VueRouter({
  mode: 'history',
  routes: [
    homeRoutes,
    ...staticRoutes,
    contactRoutes,
    trackOrderRoutes,
    orderSummaryRoutes,
    cartRoutes,
    checkoutRoutes,
    thankYouRoutes,
    marketplaceRoutes,
    ...accountRoutes,
    ...designerRoutes,
    collectionRoutes,
    salesRoutes,
    ...errorRoutes,
  ],
});

export default router;